import { BreakpointsOptions } from "@mui/material";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    xs: false; // removes the `xs` breakpoint
    sm: false;
    md: false;
    lg: false;
    xl: false;
    desktop: true;
    min: true;
    max: true;
    smallPhone: true;
    laptop: true;
  }
}

export const breakpoints: BreakpointsOptions = {
  values: {
    min: 360,
    smallPhone: 640,
    desktop: 1024,
    laptop: 1360,
    max: 1920,
  },
};
